import PinSolidSVG from "@design-system/ui-icons/vanilla/PinSolid"
import { createIcon } from "../createIcon"

export const PinSolidIcon = createIcon(PinSolidSVG)
